import React from 'react';

export default props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13.982" viewBox="0 0 14 13.982">
            <path id="x002_-_E111" data-name="x002 - E111" d="M2.435-40.279,1.146-41.55l-5.7,5.7-5.72-5.7-1.289,1.271,5.72,5.72-5.72,5.72,1.289,1.271,5.72-5.72,5.7,5.72,1.289-1.271-5.72-5.72Z" transform="translate(11.565 41.55)" fill={props.black ? "#1f1f1f" : "#FFFFFF"} />
        </svg>
    );
}
